import { client } from "../../infrastructure/graphql/client";
import { GET_ACTIVE_RESERVATIONS_WITH_VMS } from "../../infrastructure/graphql/reservationQueries";

export class ReservationService {
    async getActiveReservationsWithLinkedVms() {
        try {
            const result = await client.query({
                query: GET_ACTIVE_RESERVATIONS_WITH_VMS,
                fetchPolicy: "network-only",
            });

            const response = result.data?.getActiveReservationsWithLinkedVms;

            if (!response) {
                return {
                    success: false,
                    message: "No response from server",
                    data: null,
                };
            }

            return {
                success: true,
                data: response,
            };
        } catch (error) {
            console.error("Get active reservations error:", error);
            const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
            return {
                success: false,
                message: errorMessage,
                data: null,
            };
        }
    }
}